import { AppRouteGroup } from 'routing/classes/AppRouteGroup';

export const embedSearchWidgetRouteGroup = new AppRouteGroup(
  '/:lang/embed-search-widget/:embedSearchWidgetId',
);

// Volops

export const embedSearchWidgetVolopsRouteGroup =
  embedSearchWidgetRouteGroup.subgroup('volops');

export const embedSearchWidgetSearchVolopsRoute =
  embedSearchWidgetVolopsRouteGroup.rootRoute([
    'areasOfFocus',
    'functions',
    'locationType',
    'locale',
    'radius',
    'recency',
    'source',
    'startsLT',
    'endsGT',
    'q',
    'page',
    'sort',
  ]);

export const embedSearchWidgetViewVolopRoute =
  embedSearchWidgetVolopsRouteGroup.route(':volopId');

// Orgs

export const embedSearchWidgetOrgsRouteGroup =
  embedSearchWidgetRouteGroup.subgroup('orgs');

export const embedSearchWidgetViewOrgRoute =
  embedSearchWidgetOrgsRouteGroup.route(':orgId');
